import { useMemo } from 'react';
import { Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { deserializeSlateMarkedValue } from 'src/lib/slate';

import Paragraph from './components/Paragraph';
import useStyles from './useStyles';

export const MarkedText = ({ className, text, markup, hideMarks }) => {
  const styles = useStyles();

  const paragraphs = useMemo(() => deserializeSlateMarkedValue({ text, markup }), [text, markup]);

  return (
    <Typography
      className={cx(styles.root, className, {
        [styles.displayMarks]: !hideMarks,
      })}
      component="div"
    >
      {paragraphs.map((paragraph, index) => (
        <Paragraph
          key={index}
          data={paragraph}
        />
      ))}
    </Typography>
  );
};

MarkedText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  markup: PropTypes.arrayOf(PropTypes.shape()),
  hideMarks: PropTypes.bool,
};
MarkedText.defaultProps = {
  className: '',
  text: '',
  markup: [],
  hideMarks: false,
};
